'use client'

import { useMutation } from "@tanstack/react-query"
import { API_Error, API_Success_Response } from "@/interfaces/api/response/api_response_types"
import { API_Request_Code_Response } from "@/interfaces/api/login/forgotPassword/api_response_types"
import { requestPasswordCode } from "../requests/user"

export const useRequestPasswordCode = () => useMutation<API_Success_Response<API_Request_Code_Response>, API_Error, string>({
    retry: false,
    mutationFn: requestPasswordCode
})